import "core-js/modules/es.regexp.exec.js";
var matcher = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export var isEmail = function isEmail(string) {
  if (string.length > 320) return false;
  return matcher.test(string);
};